import { useContext } from 'react';

import UsageHistoryTab from '@/react_app/components/BillingUsage/UsageHistory/UsageHistoryTab';
import { UsageHistoryContext } from '@/react_app/components/BillingUsage/contexts';
const SettingsUsageBillingUsageHistoryAutomation = () => {
	const usageHistoryContext = useContext(UsageHistoryContext);
	if (!usageHistoryContext) {
		return null;
	}
	return <UsageHistoryTab {...usageHistoryContext.automation} />;
};
export default SettingsUsageBillingUsageHistoryAutomation;
